import { AxiosResponse } from "axios";
import { Axios } from "./Axios";
import { TypeMenu } from "../Models/Menu";
import { TypeUsuario } from "../Models/Usuario";
import { TypeSessao } from "../Models/Sessao";
import { InferQueryTypeFromAxiosFn } from "@/Utils/RequisicaoUtilitario";
import { useQuery } from "@tanstack/react-query";

export class UsuarioService {

    public listarMenu(todos = false): Promise<AxiosResponse<TypeMenu[]>>{
        if(todos){
            return Axios.get<TypeMenu[]>(`Menu/todos`);
        }

        return Axios.get<TypeMenu[]>(`Menu/`);
    }

    public logar(dadosLogin: {usuario: string, senha: string}): Promise<AxiosResponse<TypeSessao>>{
        return Axios.post<TypeSessao>(`Usuario/login`, dadosLogin);
    }

    public validarToken(token: string): Promise<AxiosResponse<{usuario: TypeUsuario, token: string}>>{
        return Axios.post<{usuario: TypeUsuario, token: string}>(`Usuario/validarToken`, token);
    }

    public alterarSenha(param: { senhaAtual: string, novaSenha: string, novaSenhaConf: string }): Promise<AxiosResponse<boolean>>{
        return Axios.patch<boolean>("Usuario/alterarSenha", param);
    }

    public configurarPrimeiraSenha(param: { usuario: string, senhaAtual: string, novaSenha: string, novaSenhaConf: string }): Promise<AxiosResponse<TypeSessao>>{
        return Axios.put<TypeSessao>("Usuario/primeira-senha", param);
    }

    public listarUsuarios(filtro: Partial<TypeUsuario>): Promise<AxiosResponse<Omit<TypeUsuario, "senha">[]>>{
        return Axios.post<Omit<TypeUsuario, "senha">[]>("Usuario/listar", filtro);
    }
    
    public verificarDisponibilidade(params: { nomeDeUsuario?: string, email?: string }): Promise<AxiosResponse<{nomeDeUsuario?: boolean, email?: boolean}>>{
        return Axios.post<{nomeDeUsuario?: boolean, email?: boolean}>(`Usuario/disponibilidade/`, params);
    }

    public inserirUsuario(usuario: Omit<TypeUsuario, "senha" | "codigo" | "ativo" > ): Promise<AxiosResponse<TypeUsuario>>{
        return Axios.post<TypeUsuario>(`Usuario/inserir`, usuario);
    }

    public atualizarUsuario(usuario: Omit<TypeUsuario, "senha" | "ativo">): Promise<AxiosResponse> {
        return Axios.put(`Usuario/atualizar`, usuario);
    }

    public ativarUsuario(codigo: number): Promise<AxiosResponse> {
        return Axios.post(`Usuario/ativar/${codigo}`);
    }

    public desativarUsuario(codigo: number): Promise<AxiosResponse> {
        return Axios.post(`Usuario/desativar/${codigo}`);
    }

    public recuperarSenha(usuario: TypeUsuario["usuario"]): Promise<AxiosResponse> {
        return Axios.post(
            `Usuario/recuperar-senha/`,
            { usuario }
        );
    }

}

export function useListarTodosUsuarios(
    {config, params}: InferQueryTypeFromAxiosFn<typeof UsuarioService.prototype.listarUsuarios>
) {
    const query = useQuery({
        queryKey: ["Usuario", "Usuario.Listar", params],
        queryFn: async () => {
            return new UsuarioService().listarUsuarios(...params);
        },
        enabled: false,
        staleTime: 60 * 1000,
        ...config,
    });

    return query;
}
